import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Paper,
  Container,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "../../AuthContext/AuthContext";
import BottomNavbar from "../../Users/Rent Module/BottomNavbar/BottomNavbar";

const WantedProperties = () => {
  const navigate = useNavigate();

  // ✅ Take userId from AuthContext
  const { userId, logout } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ userId added to API
        const res = await axios.get(
          `https://landnest.net:81/property-request/?userId=${userId}`
        );

        setData(res.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load data");
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    }
  }, [userId]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `
          linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
          url('/construction4.png')
        `,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        pb: 8,
      }}
    >
      {/* ===================== TOP BAR ===================== */}
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: `
            linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: "#fff",
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.1)",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <Typography
            variant="h6"
            sx={{ marginLeft: 2, fontWeight: 600, color: "#fff" }}
          >
            Wanted Properties
          </Typography>
        </Toolbar>
      </AppBar>

      {/* ===================== CONTENT ===================== */}
      <Container sx={{ py: 2 }}>
        {loading && (
          <Typography align="center" sx={{ mt: 3 }}>
            Loading...
          </Typography>
        )}

        {error && (
          <Typography color="error" align="center" sx={{ mt: 3 }}>
            {error}
          </Typography>
        )}

        {!loading &&
          !error &&
          data.map((item) => (
            <Paper
              key={item.req_id}
              sx={{
                p: 2,
                mb: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Looking For:{" "}
                <span style={{ color: "green" }}>{item.looking_for}</span>
              </Typography>

              <Typography>
                <strong>Location:</strong> {item.location}
              </Typography>

              <Typography>
                <strong>Property Type:</strong> {item.property_type}
              </Typography>

              <Typography>
                <strong>Budget:</strong> ₹
                {item.min_budget.toLocaleString()} - ₹
                {item.max_budget.toLocaleString()}
              </Typography>

              {item.min_acres > 0 && (
                <Typography>
                  <strong>Acres:</strong> {item.min_acres} - {item.max_acres}
                </Typography>
              )}

              {(item.length > 0 || item.width > 0) && (
                <Typography>
                  <strong>Size:</strong> {item.length} × {item.width}{" "}
                  {item.units}
                </Typography>
              )}

              <Typography sx={{ opacity: 0.7 }}>
                <strong>Comment:</strong> {item.comment}
              </Typography>

              <Typography sx={{ opacity: 0.5, fontSize: "12px" }}>
                Posted on: {new Date(item.created_at).toLocaleString()}
              </Typography>
            </Paper>
          ))}
      </Container>

      {/* ===================== BOTTOM NAV ===================== */}
      <BottomNavbar />
    </Box>
  );
};

export default WantedProperties;
